var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var redirectPolicy_exports = {};
__export(redirectPolicy_exports, {
  redirectPolicy: () => redirectPolicy,
  redirectPolicyName: () => redirectPolicyName
});
module.exports = __toCommonJS(redirectPolicy_exports);
var import_policies = require("@typespec/ts-http-runtime/internal/policies");
const redirectPolicyName = import_policies.redirectPolicyName;
function redirectPolicy(options = {}) {
  return (0, import_policies.redirectPolicy)(options);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  redirectPolicy,
  redirectPolicyName
});
